import { useAtom } from 'jotai';
import { showAvailableState, showFirstTimePopupAtom } from '../states/planner';

export const FirstTimePopup = () => {
  const [showFirstTimePopup, setFirstTimePopup] = useAtom(showFirstTimePopupAtom);
  const [, setShowAvailable] = useAtom(showAvailableState);

  return (
    <>
      {/* Overlay to close the popup */}
      <div
        className={`absolute left-0 top-0 h-full w-full cursor-default ${showFirstTimePopup ? 'visible' : 'invisible'}`}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setFirstTimePopup(false)}
        onClick={() => {
          setFirstTimePopup(false);
          setShowAvailable(false);
        }}
      ></div>

      {/* Popup dialog */}
      {/* Popup dialog */}
      <div
        className={`absolute left-1/2 top-[5%] w-64 -translate-x-1/2 transform rounded-md bg-black p-3 text-xs text-white shadow-lg transition-all duration-300 ease-out sm:top-[10%] sm:w-80 sm:text-base ${
          showFirstTimePopup ? 'visible scale-100 opacity-80' : 'invisible scale-90 opacity-0'
        }`}
        id="viewSelector"
      >
        <div className="flex flex-col items-center justify-center gap-2 text-center">
          Klicka i bilden för att se mer information
        </div>
      </div>
    </>
  );
};
